export enum Types {
  SingIn = "SIGN_IN",
  OnReLoad = "ON_RELOAD",
  SingOut = "SIGN_OUT",
  RefreshTokens = "REFRESH_TOKEN",
}
